<ul class="details-list">
  <li *ngIf="report.grossPotentialRent != undefined">
    <label>Gross Potential Rent</label>
    <span>
      <span class="value">{{ report.grossPotentialRent | terraCurrency }} </span>
      <span class="unit">{{ holdingCurrency.iso }}</span>
    </span>
  </li>
  <li *ngIf="report.vacancyLoss != undefined">
    <label>Vacancy Loss</label>
    <span>
      <span class="value">{{ report.vacancyLoss | terraCurrency }} </span>
      <span class="unit">{{ holdingCurrency.iso }}</span>
    </span>
  </li>
  <li *ngIf="report.delinquentRent != undefined">
    <label>Delinquent Rent</label>
    <span>
      <span class="value">{{ report.delinquentRent | terraCurrency }} </span>
      <span class="unit">{{ holdingCurrency.iso }}</span>
    </span>
  </li>
  <li *ngIf="report.income != undefined">
    <label>Income</label>
    <span>
      <span class="value">{{ report.income | terraCurrency }} </span>
      <span class="unit">{{ holdingCurrency.iso }}</span>
    </span>
  </li>

  <li *ngIf="report.expenses != undefined">
    <label>Expenses</label>
    <span>
      <span class="value">{{ report.expenses | terraCurrency }} </span>
      <span class="unit">{{ holdingCurrency.iso }}</span>
    </span>
  </li>

  <li *ngIf="report.assetManagementFees != undefined">
    <label>Asset Management Fees</label>
    <span>
      <span class="value">{{ report.assetManagementFees | terraCurrency }} </span>
      <span class="unit">{{ holdingCurrency.iso }}</span>
    </span>
  </li>


  <li *ngIf="report.netOperatingIncome != undefined">
    <label>Net Operating Income (NOI)</label>
    <span>
      <span class="value">{{ report.netOperatingIncome | terraCurrency }} </span>
      <span class="unit">{{ holdingCurrency.iso }}</span>
    </span>
  </li>

  <li *ngIf="!!report.debtService">
    <label>Debt Service</label>
    <span>
      <span class="value">{{ report.debtService | terraCurrency }} </span>
      <span class="unit">{{ holdingCurrency.iso }}</span>
    </span>
  </li>

  <li *ngIf="!!report.capitalExpenditures">
    <label>Capital Expenditures</label>
    <span>
      <span class="value">{{ report.capitalExpenditures | terraCurrency }} </span>
      <span class="unit">{{ holdingCurrency.iso }}</span>
    </span>
  </li>

  <li *ngIf="report.netIncome != undefined">
    <label>Net Income</label>
    <span>
      <span class="value">{{ report.netIncome | terraCurrency }} </span>
      <span class="unit">{{ holdingCurrency.iso }}</span>
    </span>
  </li>

  <li *ngIf="report.vacancyRate != undefined">
    <label>Vacancy Rate</label>
    <span>
      <span class="value">{{ report.vacancyRate | terraNumber }} </span>
      <span class="unit">%</span>
    </span>
  </li>

  <li *ngIf="report.delinquentRate != undefined">
    <label>Delinquent Rate</label>
    <span>
      <span class="value">{{ report.delinquentRate | terraNumber }} </span>
      <span class="unit">%</span>
    </span>
  </li>

  <li *ngIf="report.operatingExpense != undefined">
    <label>% Operating Expense</label>
    <span>
      <span class="value">{{ report.operatingExpense | terraNumber }} </span>
      <span class="unit">%</span>
    </span>
  </li>
  <!-- Obsolete (for old reports) -->
  <li *ngIf="holdingDiscriminator === HoldingDiscriminator.Asset && reportAsAssetReport.occupancy !== null && reportAsAssetReport.occupancy !== undefined">
    <label>Occupancy</label>
    <span>
      <span class="value">{{ reportAsAssetReport.occupancy }} </span>
      <span class="unit">%</span>
    </span>
  </li>
</ul>

<!-- Textual information -->
<div class="textual-information-section">
  <mat-action-list>
    <button class="list-button" mat-list-item *ngIf="report.summary" (click)="showSimpleInfoDialog('Summary', report.summary)">
      Summary <mat-icon mat-list-icon class="notranslate">arrow_forward</mat-icon>
    </button>
    <!--  Asset related data  -->
    <button class="list-button" mat-list-item *ngIf="holdingDiscriminator === HoldingDiscriminator.Asset && reportAsAssetReport.assetUpdates"
            (click)="showSimpleInfoDialog('Asset updates', reportAsAssetReport.assetUpdates)">
      Asset Updates <mat-icon mat-list-icon class="notranslate">arrow_forward</mat-icon>
    </button>

    <button class="list-button" mat-list-item *ngIf="holdingDiscriminator === HoldingDiscriminator.Asset && reportAsAssetReport.tenantsUpdates"
            (click)="showSimpleInfoDialog('Tenants updates', reportAsAssetReport.tenantsUpdates)">
      Tenants Updates <mat-icon mat-list-icon class="notranslate">arrow_forward</mat-icon>
    </button>

    <button class="list-button" mat-list-item *ngIf="holdingDiscriminator === HoldingDiscriminator.Asset && reportAsAssetReport.cashFlowUpdates"
            (click)="showSimpleInfoDialog('Cash Flow updates', reportAsAssetReport.cashFlowUpdates)">
      Cash Flow Updates <mat-icon mat-list-icon class="notranslate">arrow_forward</mat-icon>
    </button>

    <button class="list-button" mat-list-item *ngIf="holdingDiscriminator === HoldingDiscriminator.Asset && reportAsAssetReport.marketUpdates"
            (click)="showSimpleInfoDialog('Market updates', reportAsAssetReport.marketUpdates)">
      Market Updates <mat-icon mat-list-icon class="notranslate">arrow_forward</mat-icon>
    </button>

    <!--  Fund related data  -->
    <button class="list-button" mat-list-item *ngIf="holdingDiscriminator === HoldingDiscriminator.Fund && reportAsFundReport.capitalInformation"
            (click)="showSimpleInfoDialog('Capital information', reportAsFundReport.capitalInformation)">
      Capital Information <mat-icon mat-list-icon class="notranslate">arrow_forward</mat-icon>
    </button>

    <button class="list-button" mat-list-item *ngIf="holdingDiscriminator === HoldingDiscriminator.Fund && reportAsFundReport.acquisitionsDispositions"
            (click)="showSimpleInfoDialog('Acquisitions & Dispositions', reportAsFundReport.acquisitionsDispositions)">
      Acquisitions & Dispositions <mat-icon mat-list-icon class="notranslate">arrow_forward</mat-icon>
    </button>

    <button class="list-button" mat-list-item *ngIf="holdingDiscriminator === HoldingDiscriminator.Fund && reportAsFundReport.holdingUpdates"
            (click)="showSimpleInfoDialog('Portfolio updates', reportAsFundReport.holdingUpdates)">
      Portfolio Updates <mat-icon mat-list-icon class="notranslate">arrow_forward</mat-icon>
    </button>

    <button class="list-button" mat-list-item *ngIf="holdingDiscriminator === HoldingDiscriminator.Fund && reportAsFundReport.administrativeUpdates"
            (click)="showSimpleInfoDialog('Administrative updates', reportAsFundReport.administrativeUpdates)">
      Administrative Updates <mat-icon mat-list-icon class="notranslate">arrow_forward</mat-icon>
    </button>

    <button class="list-button" mat-list-item *ngIf="report.faQs?.length" (click)="showFaqsDialog(report.faQs)">
      FAQs About this Report ({{ report.faQs.length }})<mat-icon mat-list-icon class="notranslate">arrow_forward</mat-icon>
    </button>
  </mat-action-list>
</div>

<!-- Download report file -->
<ng-container *ngIf="getReportDocumentFileUrl(report) as reportDocumentUrl">
  <div class="download-report-section">
    <a download [href]="isGpPreviewMode ? '' : reportDocumentUrl" *ngIf="!isExample" type="button" mat-stroked-button color="primary" target="_blank"
       class="download-report-button tall-button">
      DOWNLOAD FULL REPORT
    </a>
  </div>
</ng-container>

<div class="attachments-section" [ngClass]="{ 'example-strip': isExample }">
  <!-- Images, Videos, audio files -->
  <ng-container *ngIf="getImagesVideoAudioFiles(report) as files">
    <ng-container *ngIf="files.length > 0">
      <h2 class="section-title">Images and Videos</h2>
      <div class="media-files">
        <terra-media-thumbnail *ngFor="let file of files" [isClickable]="!isExample && !isGpPreviewMode" [metaFileLink]="file">
        </terra-media-thumbnail>
      </div>
    </ng-container>
  </ng-container>

  <!-- Other attachments -->
  <ng-container *ngIf="getMediaFilesNotImageVideo(report) as files">
    <ng-container *ngIf="files.length > 0">
      <h2 class="section-title additional-attachments-title">Additional Attachments</h2>
      <div class="media-files">
        <terra-document-thumbnail *ngFor="let file of files" [isClickable]="!isExample && !isGpPreviewMode" [metaFileLink]="file" truncateSize="30">
        </terra-document-thumbnail>
      </div>
    </ng-container>
  </ng-container>
</div>
